import styled from '@emotion/styled'

export const Header = styled.div`
  align-items: flex-start;
  display: flex;
  flex-direction: column;
  font-family: Satoshi;
  font-weight: 700;
  font-size: 54px;
  line-height: 64px;
  letter-spacing: 0%;

  @media (max-width: 768px) {
    align-items: center;
    font-size: 30px;
    justify-content: center;
    line-height: 40px;
    text-align: center;
    width: 100%;
  }
`
